import React from 'react'
import { Nav, NavDropdown } from 'react-bootstrap'
import styles from '../Header.module.css'
import { Item } from '../Header'
import useHoverDropdown from '../useHoverDropdown'

const IntegrationsDropdown = () => {
  const hoverProps = useHoverDropdown()

  return (
    <Nav.Item className="integration-tab">
      <NavDropdown
        className="p-md-0 m-auto dropdown-toggle"
        title={
          <span className={styles.contentBoxNav}>
            <img src="/assets/icons/power.svg" alt="Integrations" className={styles.img} />
            <span className={styles.contentText}>Integrations</span>
          </span>
        }
        variant="link"
        {...hoverProps}
      >
        <div className={`${styles.menu} ${styles.twoColumnMenu}`}>
          <div className={styles.contentContainer}>
            <div className={`${styles.twoColumn} ${styles.equalColumns}`}>
              <Item
                icon="cog.svg"
                alt="API"
                label="API & MCP"
                href="https://api-docs.tiiny.host"
                target="_blank"
                subtitle="Upload via the tiiny API"
              />
              <Item
                icon="openai.svg"
                alt="chatGPT"
                label="ChatGPT"
                href="https://chatgpt.com/g/g-6731c3a9f8a48190b445f7d2c8d4f817-app-website-generator-by-tiinyhost"
                target="_blank"
                subtitle="Build apps & websites"
              />
              <Item
                icon="chrome.svg"
                alt="Google Chrome"
                label="Google Chrome"
                href="https://chromewebstore.google.com/detail/tiny-host/meippdeigckopliglcajepbiaoaccflc"
                target="_blank"
                subtitle="Upload from your browser"
              />
              <Item
                icon="n8n.png"
                alt="n8n"
                label="n8n"
                href="https://n8n.io/integrations/tiiny-host/"
                target="_blank"
                subtitle="Upload via automations"
              />
              <Item
                icon="vs-code.png"
                alt="VS Code"
                label="VS Code"
                href="https://marketplace.visualstudio.com/items?itemName=TiinyHost.tiinyhost"
                target="_blank"
                subtitle="Upload from your IDE"
              />
              <Item
                icon="zapier.png"
                alt="Zapier"
                label="Zapier"
                href="https://zapier.com/apps/tiiny-host/integrations"
                target="_blank"
                subtitle="Upload via automations"
              />
              <Item
                icon="claude.webp"
                alt="Claude"
                label="Claude"
                href="https://helpdesk.tiiny.host/en/article/how-to-connect-tiiny-host-to-claude-with-mcp-14z1okp/"
                target="_blank"
                subtitle="Upload via Claude Connector"
              />
              <Item
                icon="make-logo.png"
                alt="Make"
                label="Make"
                href="https://www.make.com/en/integrations/tiiny"
                target="_blank"
                subtitle="Upload via automations"
              />
            </div>
          </div>
        </div>
      </NavDropdown>
    </Nav.Item>
  )
}

export default IntegrationsDropdown
